import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import Select from "react-select";
import {
  ASSOCIER_COORDO_EQUIPE,
  LISTE_EQUIPE_COORDO,
  LISTE_NON_ASSOSCIER_COORDO_EQUIPE,
} from "../../Utils/constant";
import { find, store } from "../../services/service";
import { useEquipeStore } from "../../store/EquipeStore";

export const AssociateTeam = ({ id }) => {
  const equipes = [];
  const { handleSubmit, reset } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);
  const [select, setSelect] = useState([]);
  const [listeEquipe, setListeEquipe] = useState([]);

  const equipe = useEquipeStore();

  const submit = (data) => {
    setIsSubmit(true);
    store(ASSOCIER_COORDO_EQUIPE, "application/json", {
      ...data,
      coordinateurId: id,
      equipeIds: select.map((item) => item.value),
    })
      .then((res) => {
        setIsSubmit(false);
        if (res.status === 200) {
          equipe.getEquipePrestataire(
            LISTE_EQUIPE_COORDO + "/" + id + `?param=&page=0&size=10`,
          );
          document.getElementById("associate_Team").close();
          reset();
          toast.success("Equipe enregistrée ");
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        toast.error("Une erreur est survenue");
      });
  };

  const getListeEquipe = async () => {
    await find(LISTE_NON_ASSOSCIER_COORDO_EQUIPE + id).then((res) => {
      setListeEquipe(res.data?.donnee);
    });
  };

  useEffect(() => {
    getListeEquipe();
  }, []);

  listeEquipe?.map((item) => {
    return equipes.push({ value: item.id, label: item.designation });
  });

  return (
    <>
      <form onSubmit={handleSubmit(submit)} className="px-2">
        <div className="my-4 space-y-4">
          <div className="my-2">
            <label htmlFor="" className="text-sm font-medium">
              Equipe <span className="text-red-500">*</span>
            </label>
            <Select isMulti onChange={(e) => setSelect(e)} options={equipes} />
          </div>

          <button
            type="submit"
            disabled={isSubmit ? true : false}
            className={`${
              !isSubmit ? "text-black bg-main" : "text-slate-800 bg-slate-200 "
            } w-full my-3 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-bold rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800`}
          >
            {!isSubmit ? "Enregistrer" : "Veuillez patientez..."}{" "}
            {isSubmit ? (
              <span className="loading loading-dots loading-xs"></span>
            ) : null}
          </button>
        </div>
      </form>
    </>
  );
};
